import MilkBottle from '../assets/img/mm/milk.svg'
import Eggitem from '../assets/img/mm/egg.svg'
import Fishitem from '../assets/img/mm/fish.svg'
import Wheat from '../assets/img/mm/wheat.svg'
import peanut from '../assets/img/mm/Peanut.svg'
import Treenuts from '../assets/img/mm/Treenuts.svg'
import soy from '../assets/img/mm/soy.svg'
import Shellfish from '../assets/img/mm/Shellfish.svg'
import Sesame from '../assets/img/mm/Sesame.svg';
import Gluten from '../assets/img/mm/gluten.svg';
import Crab from '../assets/img/mm/crab.svg';
import Lactose from '../assets/img/mm/lactose.svg';
import Nuts from '../assets/img/mm/nuts.svg';
import Celery from '../assets/img/mm/celery.svg';
import Mustard from '../assets/img/mm/mustard.svg';
import Snail from '../assets/img/mm/snails.svg';
import Lupins from '../assets/img/mm/lupins.svg';
import Dioxido from '../assets/img/mm/dioxido.svg';

export const env = { dev: "Development", prod: "Production" }
export const ENVIRONMENT = env.prod //env.dev
export const ENV = process.env.REACT_APP_ENV || 'Development';
export const BASE_URL = process.env.REACT_APP_BASEURL;
export const BASE_URL_2 = process.env.REACT_APP_BASEURL + "/mealManage";
export const BASE_URL_1 = process.env.REACT_APP_BASEURL + "/mealManage";
export const BASE_URL_3 = process.env.REACT_APP_PARENTAPI_BASEURL;
export const RECIPE_BASE_URL = process.env.REACT_APP_RECOPE_BASEURL + '/recipe-management';
export const webURL = process.env.REACT_APP_WEBURL;
export const URL_VERSION = '/v2';
export const URL_VERSION3 = '/v3';
export const PARTNER_PAYMENT_URL = ENVIRONMENT === env.dev ? "https://www.schoolcashonline.com/Home/SignIn" : "https://www.schoolcashonline.com/Home/SignIn";
export const parentAndroidPayStoreUrl = process.env.REACT_APP_ANDROID_STORE_URL;
export const parentIosPayStoreUrl = process.env.REACT_APP_APPLE_STORE_URL;
export const CATERER_WEB_URL = process.env.REACT_APP_CATERER_WEB_URL;
//export const BASE_URL = 'http://DESKTOP-8QKFBMH:8296';
//export const BASE_URL_2 = 'http://DESKTOP-8QKFBMH:8296/mealManage';
//export const BASE_URL_1 = 'http://DESKTOP-8QKFBMH:8296/mealManage';
export const UPAY_URL = process.env.REACT_APP_UPAY_URL;
export const PAYMAYA_URL = process.env.REACT_APP_PAYMAYA_URL;
/* Environment variales end */

export const WEEKDAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
export const partnerSchoolList = process.env.REACT_APP_PARTNER_SCHOOL_LIST || '';
export const grades = [{ 'K-6': ['K', 1, 2, 3, 4, 5, 6] }, { HS: [7, 8, 9, 10, 11, 12] }];
export const staffGrades = ['staff', 'staffh'];
export const preSchoolGrades = ['pk', 'k', 'kg'];
export const access_token = (function () {
    return sessionStorage.getItem('access_token');
});
export const currency_symbol = (function (sid = 0) {
    let symb = '$';
    try {
        if (sid === 0) {
            return sessionStorage.getItem('currency_symbol')
        } else {
            const obj = JSON.parse((sessionStorage.getItem('currency_symbol') || '') == '' ? [] : sessionStorage.getItem('currency_symbol')) || {};
            symb = obj[sid];
        }
    } catch (ex) {
    }
    return symb;
});
export function getPageSizeForPrintByCountry(sid = 0) {
    let pageSize = {};
    const pageSizeObj = {
        'US': { w: '8.5in', h: '11in' },
        'ES': { w: '8.27in', h: '11.69in' },
        'IN': { w: '8.27in', h: '11.69in' },
        'GB': { w: '8.27in', h: '11.69in' },
        'ZA': { w: '8.27in', h: '11.69in' },
        'KR': { w: '8.27in', h: '11.69in' },
        'EG': { w: '8.27in', h: '11.69in' },
        '': { w: '8.5in', h: '11in' }
    }
    pageSize = pageSizeObj[sessionStorage.getItem('countryCode') || ''] || { w: '8.5in', h: '11in' };
    try {
        if (sid === 0) {
            const _pageSize = (sessionStorage.getItem('pageSize') || '{}' == '{}' ? pageSize : JSON.parse(sessionStorage.getItem('pageSize')));
            return _pageSize === "" ? pageSize : _pageSize;
        } else {
            const obj = (sessionStorage.getItem('pageSize') || '{}' == '{}' ? [] : JSON.parse(sessionStorage.getItem('pageSize')) || {});
            const _pPageSize = obj[sid] === "" ? pageSize : obj[sid];
            pageSize = _pPageSize;
        }
    } catch (ex) {
        return pageSize;
    }
}
export const dial_code = (function (sid = 0) {
    let symb = '+1';
    try {
        if (sid === 0) {
            return sessionStorage.getItem('ISD_code')
        } else {
            const obj = JSON.parse((sessionStorage.getItem('ISD_code') || '') == '' ? [] : sessionStorage.getItem('ISD_code')) || {};
            symb = obj[sid];
        }
    } catch (ex) {
    }
    return symb;
});
export const mobileNoLength = (function (sid = 0) {
    let symb = 10;
    try {
        if (sid === 0) {
            return parseInt(sessionStorage.getItem('phoneValidation'));
        } else {
            const obj = JSON.parse((sessionStorage.getItem('phoneValidation') || '') == '' ? [] : sessionStorage.getItem('phoneValidation')) || {};
            symb = parseInt(obj[sid] || 10);
        }
    } catch (ex) {
    }
    return symb;
});
export const date_format = (function (sid = 0) {
    //let format = 'yyyy/mm/dd';
    let format = 'MM/DD/YYYY';
    //let ccd=sessionStorage.getItem('country_code')
    try {
        if (sid == 0) {
            return sessionStorage.getItem('date_format').toUpperCase()
        } else {
            const obj = JSON.parse((sessionStorage.getItem('date_format').toUpperCase() || '') == '' ? [] : sessionStorage.getItem('date_format').toUpperCase()) || {};
            format = obj[sid];
        }
    } catch (ex) {
    }
    return format;
});
export const getCustomAppFee = (sid = 0) => {
    let appFee = null;
    try {
        if (sid > 0) {
            const appFeeObj = sessionStorage.getItem('appFee');
            appFee = JSON.parse(appFeeObj)[sid];
        }

    } catch (ex) {

    }
    return appFee;
}
export const stripeInfo = (function (sid = 0) {
    let customAppFee = getCustomAppFee(sid);
    const stripeCurrencyinfo = {
        'US': { currencyCode: 'USD', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 },
        'IN': { currencyCode: 'INR', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 },
        'EG': { currencyCode: 'EGP', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 },
        'ES': { currencyCode: 'EUR', transaction_Charge: 1.4, transaction_Other_Charge: 0.25, application_free: 0.20, monetary_unit: 100 },
        'KR': { currencyCode: 'KRW', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 },
        'UK': { currencyCode: 'EUR', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 },
        'CA': { currencyCode: 'CAN', transaction_Charge: 2.9, transaction_Other_Charge: 0.30, application_free: 0.20, monetary_unit: 100 }
    }
    let symb = undefined;
    try {
        if (sid === 0) {
            return stripeCurrencyinfo[sessionStorage.getItem('countryCode')] || {};
        } else {
            const obj = JSON.parse((sessionStorage.getItem('countryCode') || '') == '' ? [] : sessionStorage.getItem('countryCode')) || {};
            symb = stripeCurrencyinfo[obj[sid]];
            if (!symb) {
                symb = stripeCurrencyinfo.US;
            }
            if (customAppFee) {
                symb.application_free = customAppFee
            }
        }
    } catch (ex) {
    }
    return symb;
});
export const my_PUBLISHABLE_stripekey = process.env.REACT_APP_PUBLISHABLE_STRIPEKEY;
//export const my_PUBLISHABLE_stripekey= 'pk_live_YDHrtrbdm940cWONI0BHARiQ'
export const domains = ['https://', 'http://', 'www.', 'devapp.', 'devappv2.', 'app.', '.com'];
export const catererDomains = ['devkitchen.', 'kitchen.'];
export const districtDomains = ['devdistrict.', 'district.'];
export const transaction_Charge = 2.9;
export const transaction_Other_Charge = 0.30;
export const application_free = 0.20;
export const updatedNutritions = {
    "calories": { display: 'Calories *', tabindex: 1, isRequired: true, code: 208 },
    "protein": { display: 'Protein (g) *', tabindex: 2, isRequired: true, code: 203 },
    "cholestral": { display: 'Cholesterol (mg) *', tabindex: 3, isRequired: true, code: 601 },
    "saturatedFat": { display: 'Saturated Fat (g) *', tabindex: 4, isRequired: true, code: 606 },
    "totalFat": { display: 'Total Fat (g) *', tabindex: 5, isRequired: true, code: 204 },
    "totalCarbohydrate": { display: 'Total Carbohydrates (g) *', tabindex: 6, isRequired: true, code: 205 },
    "sugars": { display: 'Sugar (g) *', tabindex: 7, isRequired: true, code: 269 },
    "sodium": { display: 'Sodium (mg)', tabindex: 8, code: 307 },
    "dietaryFiber": { display: 'Dietary fiber (g)', tabindex: 9, code: 291 },
}
export const filterAllergensByCountry = (countryCode) => {
    if (countryCode == 'US') {
        const filterObject = {};
        Object.keys(allergens).map(key => {
            if ((allergens[key] || {}).showForUS) {
                filterObject[key] = allergens[key];
            }
        });
        return filterObject;
    } else {
        return allergens;
    }
}

export const allergens = {
    "Milk": { display: 'Milk', tabindex: 1, isRequired: false, image: MilkBottle, showForUS: true },
    "Wheat": { display: 'Wheat', tabindex: 2, isRequired: false, image: Wheat, showForUS: true },
    "Eggs": { display: 'Eggs', tabindex: 3, isRequired: false, image: Eggitem, showForUS: true },
    "Soy": { display: 'Soy', tabindex: 4, isRequired: false, image: soy, showForUS: true },
    "Fish": { display: 'Fish', tabindex: 5, isRequired: false, image: Fishitem, showForUS: true },
    "Shellfish": { display: 'Shellfish', tabindex: 6, isRequired: false, image: Shellfish, showForUS: true },
    "Peanuts": { display: 'Peanuts', tabindex: 7, isRequired: false, image: peanut, showForUS: true },
    "Sesame": { display: 'Sesame', tabindex: 8, isRequired: false, image: Sesame, showForUS: true },
    "Nuts": { display: 'Nuts', tabindex: 9, isRequired: false, image: Nuts, showForUS: true },
    "TreeNuts": { display: 'TreeNuts', tabindex: 10, isRequired: false, image: Treenuts },
    "Gluten": { display: 'Gluten', tabindex: 11, isRequired: false, image: Gluten },
    "Lactose": { display: 'Lactose', tabindex: 12, isRequired: false, image: Lactose },
    "Celery": { display: 'Celery', tabindex: 13, isRequired: false, image: Celery },
    "Mustard": { display: 'Mustard', tabindex: 14, isRequired: false, image: Mustard },
    "Lupins": { display: 'Lupins', tabindex: 15, isRequired: false, image: Lupins },
    "SnailsShellfish": { display: 'Snails & Shellfish', tabindex: 16, isRequired: false, image: Snail },
    "CrabCrustaceans": { display: 'Crab & Crustaceans', tabindex: 17, isRequired: false, image: Crab },
    "SulfurDioxideSulfates": { display: 'Sulfur Dioxide & Sulfates', tabindex: 18, isRequired: false, image: Dioxido },
    "Soja": { display: 'Soja', tabindex: 19, isRequired: false, image: soy }
}

export const nutritions = {
    "calories": { display: 'Calories *', tabindex: 1 },
    "phosphorous": { display: 'Phosphorous (mg)', tabindex: 11 },
    "pantothenicAcid": { display: 'Pantothenic Acid (mg)', tabindex: 21 },
    "protein": { display: 'Protein (g) *', tabindex: 2 },
    "sodium": { display: 'Sodium (mg)', tabindex: 12 },
    "folate": { display: 'Folate (mcg)', tabindex: 22 },
    "calcium": { display: 'Calcium (mg) *', tabindex: 3 },
    "dietaryFiber": { display: 'Dietary fiber (g)', tabindex: 13 },
    "manganese": { display: 'Manganese (mg)', tabindex: 23 },
    "potassium": { display: 'Potassium (mg) *', tabindex: 4 },
    "vitaminA": { display: 'Vitamin A (mcg)', tabindex: 14 },
    "thiamin": { display: 'Thiamin (mg)', tabindex: 24 },
    "cholestral": { display: 'Cholesterol (mg) *', tabindex: 5 },
    "vitaminB6": { display: 'Vitamin B6 (mg)', tabindex: 15 },
    "niacin": { display: 'Niacin (mg)', tabindex: 25 },
    "saturatedFat": { display: 'Saturated Fat (g) *', tabindex: 6 },
    "vitaminB12": { display: 'Vitamin B12 (mcg)', tabindex: 16 },
    "copper": { display: 'Copper (mg)', tabindex: 26 },
    "totalFat": { display: 'Total Fat (g) *', tabindex: 7 },
    "vitaminC": { display: 'Vitamin C (mg)', tabindex: 17 },
    "magnesium": { display: 'Magnesium (mg)', tabindex: 27 },
    "totalCarbohydrate": { display: 'Total Carbohydrates (g) *', tabindex: 8 },
    "vitaminD": { display: 'Vitamin D (mcg)', tabindex: 18 },
    "riboFlavin": { display: 'Riboflavin (mg)', tabindex: 28 },
    "iron": { display: 'Iron (mg) *', tabindex: 9 },
    "vitaminE": { display: 'Vitamin E (mg)', tabindex: 19 },
    "selenium": { display: 'Selenium (mcg)', tabindex: 29 },
    "sugars": { display: 'Sugar (g) *', tabindex: 10 },
    "vitaminK": { display: 'Vitamin K (mcg)', tabindex: 20 },
    "zinc": { display: 'Zinc (mg)', tabindex: 30 }
}
export const category = {
    BREAKFAST: 'Breakfast',
    MEAL: 'Lunch',
    SNACK: 'Snack',
    DINNER: 'Dinner'
}
export const menuTypeCalender = {
    MONTHLY: 'Monthly',
    WEEKLY: 'Weekly',
    YEARLY: 'Yearly'
}
export const MealTypes = {
    LUNCH: 'Lunch',
    SNACK: 'Snack',
    BREAKFAST: 'Breakfast',
    DINNER: 'Dinner',
    EXTRA: 'EXTRA',
}
export const districtMealTypes = {
    LUNCH: 'Lunch',
    SNACK: 'Snack',
    BREAKFAST: 'Breakfast',
    DINNER: 'Dinner',
    EXTRA: 'EXTRA'
}
export const MealTypesTran = {
    LUNCH: 'Regular',
    EXTRA: 'ALaCarte',
}

export const MealTypesReports = {
    LUNCH: 'Lunch',
    //ITEMIZE:'Itemized',
    SNACK: 'Snack',
    BREAKFAST: 'Breakfast',
    DINNER: 'Dinner',
}
export const RadioTypesReports = {
    ALL: 'All',
    FREE: 'Free',
    REDUCED: 'Reduced',
}
export const MenuOrderTypes = {
    REGULAR: 'Regular',
    ITEMIZE: 'Itemized'
}
export const paymentGatewayOptions = {
    STRIPE: 'Stripe',
    PAYMOB: 'PayMob',
    ADDONPAY: 'ADDONPAY',
    UNIONPAY: 'UnionPay',
    PAYMAYA: 'PayMaya'
}

export const paymentOptionValues = [100, 250, 500, 1000];
export const itemizeNotWorkingDays = [5, 6];
export const regularNotWorkingDays = [0, 6];

export const ROLES = {
    SUPERADMIN: 'ROLE_SUPERADMIN',
    ADMIN: 'ROLE_ADMIN',
    CATERER: 'ROLE_CATERER',
    DISTRICT: 'ROLE_DISTRICT',
    PARENT: 'ROLE_PARENT'
}
export const BULK_TRANS_TYPE = {
    MEALCOUNT: 'Count',
    ITEMCOUNT: 'Meal item',
    STUDENT: 'Student'
}



// WEBPACK FOOTER //
// ./src/server/constants.js